import type { UserApi } from 'modules/api-client';
import { useAuth } from 'modules/auth/AuthContext';
import { type ReactChild, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthLayout } from '../../components/AuthLayout/AuthLayout';
import { ResetPasswordForm } from './ResetPasswordForm';
import { SendToken } from './SendToken';

export const ResetPassword = () => {
  const { i18n } = useTranslation();
  const { actions } = useAuth();
  const navigate = useNavigate();
  const locale = i18n.language;
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [email] = useState(params.get('email') || '');
  const [token] = useState(params.get('token') || '');

  const onResetPasswordSuccess = (user: UserApi) => {
    actions.login(user);
    navigate('/map');
  };

  let content = null as ReactChild | null;
  if (!token) {
    content = <SendToken email={email} locale={locale} />;
  } else {
    content = (
      <ResetPasswordForm
        token={token}
        email={email}
        onSuccess={onResetPasswordSuccess}
      />
    );
  }

  return <AuthLayout>{content}</AuthLayout>;
};
